import React, { useState } from "react";
import {
  Box,
  DynamicButton,
  MainHolder,
  StyledText,
  Children,
} from "../../../../components/common";
import styled from "styled-components";
import { NewBackButton, NoticeIcon } from "../../../../components/svgs";
import { Wheel } from "react-custom-roulette";
import SpinTheWheelModal from "../components/InfoModal";
import wheel_frame from "../../../../components/images/wheel_frame.png";
import wheel_pointer from "../../../../components/images/pointer.png";
import { useSpinTheWheelHome } from "../hooks";
import "../css/wheel.css";
import History from "../components/History";
import LocationChecker from "./LocationChecker";
import PointStatsModal from "../components/PointStatsModal";

const SpinTheWheelHome = () => {
  const {
    handleSpinClick,
    history,
    itemWon,
    mustSpin,
    prizeNumber,
    data,
    setData,
    showModal,
    setShowModal,
    color,
    lostChance,
    background,
    isSubmitting,
    onStopSpinning,
    canPlay,
    userHistory,
    getItemFromStock,
    hasPlayed,
    outOfStockCodes,
    isTime9amOrLater,
    whiteListedLocations,
  } = useSpinTheWheelHome();

  const goHome = () => {
    history.push("/home?token=" + JSON.parse(localStorage.getItem("token")));
  };

  return (
    <>
      <MainHolder>
        <Children style={{ paddingTop: "60px" }}>
          {
            !userHistory?.length &&
            <LocationChecker whiteListedLocations={whiteListedLocations} />}
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#fff",
              position: "absolute",
              top: 0,
              width: "100%",
              paddingTop: 5,
              paddingBottom: 5,
              justifyContent: "space-around",
            }}
          >
            <BackButtonContainer onClick={goHome}>
              <NewBackButton />
            </BackButtonContainer>

            <StyledText style={{ fontSize: 18, color: "black" }}>
              Spin the wheel
            </StyledText>
            <NoticeIcon
              fill="#000000"
              onClick={() => history.push("/spin_the_wheel/info_page")}
            />
          </Box>

          <div
            style={{
              width: "85%",
              margin: "0 auto",
              display: "flex",
              flexDirection: "column",
              alignSelf: "center",
              justifyContent: "center",
            }}
          >
            <StyledText
              style={{ textAlign: "center", fontFamily: "MTNRegular" }}
            >
              Spin the wheel and win amazing prizes. Test your luck today!
            </StyledText>
            <div
              style={{
                position: "relative",
                width: "340px",
              }}
            >
              <img style={{ width: "340px" }} src={wheel_frame} />
              {data && (
                <>
                  <div
                    style={{
                      position: "absolute",
                      top: "16px",
                      left: "15px",
                      transform: "rotate(-55deg)",
                    }}
                  >
                    {data?.length && (
                      <Wheel
                        fontFamily="MTNBold"
                        backgroundColors={color}
                        textDistance={[50]}
                        innerBorderWidth={5}
                        innerBorderColor="#C17C20"
                        radiusLineColor={"white"}
                        radiusLineWidth={1}
                        innerRadius={5}
                        outerBorderColor={"#F3F3F3"}
                        mustStartSpinning={mustSpin}
                        prizeNumber={prizeNumber}
                        data={data}
                        pointerProps={{
                          src: wheel_pointer,
                          style: { transform: "rotate(55deg)", top: "15%" },
                        }}
                        onStopSpinning={onStopSpinning}
                      />
                    )}
                  </div>

                  <div
                    style={{
                      maxWidth: "280px",
                      margin: "0 auto",
                      paddingTop: "20px",
                    }}
                  >
                    { }
                    <DynamicButton
                      fullWidth
                      disabled={
                        isSubmitting ||
                        mustSpin ||
                        !canPlay ||
                        hasPlayed ||
                        !isTime9amOrLater
                      }
                      label={
                        isTime9amOrLater ? "Spin" : "Spinning starts at 9am"
                      }
                      color={background}
                      onClick={handleSpinClick}
                    />

                    <DynamicButton
                      fullWidth
                      variant="outlined"
                      label="Orders"
                      color={background}
                      onClick={() => history.push("/spin_the_wheel/orders")}
                    />
                  </div>
                </>
              )}
            </div>
          </div>

          {userHistory?.length ? (
            <History
              data={userHistory}
              getItemFromStock={getItemFromStock}
              background={background}
            />
          ) : null}
        </Children>
      </MainHolder>
      {showModal && (
        <SpinTheWheelModal
          onBackDropClick={() => {
            setShowModal(lostChance ? false : true);
            const updatedData = data.map((item, index) => {
              if (index === prizeNumber) {
                return {
                  ...item,
                  played: true,
                };
              } else {
                return item;
              }
            });

            setData(updatedData);
          }}
          headerText={
            !itemWon?.won
              ? outOfStockCodes.includes(itemWon.code)
                ? "Out of Stock"
                : "Better luck next time"
              : "Congratulations"
          }
          emoji={!itemWon?.won ? "😔" : "🤩"}
          mainText={
            !itemWon?.won
              ? outOfStockCodes.includes(itemWon.code)
                ? `Unfortunately, this item is out of stock at the moment. Try again tomorrow to win a prize.`
                : "Unfortunately, you didn't win this time. Don't worry! Keep trying for your chance to win amazing prizes next time!"
              : `You’ve won the ${itemWon?.option} prize. Claim it now.`
          }
          buttonText={itemWon?.won ? "Claim Prize" : "Ok"}
          onButtonClick={() => {
            if (!itemWon?.won) {
              setShowModal(false);
            } else if (itemWon?.option.includes("Data")) {
              history.push("/spin_the_wheel/data_redemption");
            } else if (itemWon?.option.includes("Airtime")) {
              history.push("/spin_the_wheel/airtime_redemption");
            } else {
              history.push("/spin_the_wheel/voucher_redemption");
              setShowModal(false);
            }
          }}
        />
      )}
    </>
  );
};

export default SpinTheWheelHome;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
